import { useAccountManagedByAdobeFragment } from '@frameio/graphql-client/generated';
import { isAccountAdobeManaged } from '@frameio/graphql-client/utils/isAccountAdobeManaged';
import { useActiveAccountId } from '../contexts';

export const useAccountManagedByAdobe = () => {
  const accountId = useActiveAccountId();

  const { data } = useAccountManagedByAdobeFragment({
    from: {
      __typename: 'Account',
      id: accountId,
    },
  });

  return isAccountAdobeManaged(data?.managedBy);
};
